import React, {
    useEffect,
    useState,
    createContext,
    useMemo,
    useCallback,
    useContext,
} from 'react';
import PropTypes from 'prop-types';
import { Portal } from 'react-portal';


import LoadingPage from './LoadingPage';
import { ConfigContext } from '../ConfigProvider';


const LOADING_PORTAL_NODE = document.querySelector('[data-first-category-container]');
const HIDDEN_ON_LOADING_NODES = document.querySelectorAll('[data-additional-content]');

function showHiddenNodes() {
    const additionalEls = Array.from(HIDDEN_ON_LOADING_NODES);
    additionalEls.forEach((el) => {
        el.classList.remove('hidden');
    });
}


export const LoadingContext = createContext({
    isAppLoading: true,
});


export function useLoadingCompleteHandler() {
    const { onAppLoaded } = useContext(LoadingContext);

    useEffect(() => {
        if (onAppLoaded) {
            onAppLoaded();
        }
    }, []);
}


export function LoadingContainer(props) {
    const { children } = props;

    const [isAppLoading, setIsAppLoading] = useState(true);

    const { pageId } = useContext(ConfigContext);

    const isNYPage = pageId === 'blyuda-dlya-novogodnego-stola';

    const handleAppLoading = useCallback(() => {
        setIsAppLoading(false);
        showHiddenNodes();
    }, []);

    const contextValue = useMemo(() => {
        const value = {
            isAppLoading,
            onAppLoaded: handleAppLoading,
        };
        return value;
    }, [isAppLoading, handleAppLoading]);

    return (
        <LoadingContext.Provider value={contextValue}>
            {/* {isAppLoading && !isNYPage && (
                <Portal node={LOADING_PORTAL_NODE}>
                    <LoadingPage />
                </Portal>
            )} */}
            {isAppLoading && (
                <Portal node={LOADING_PORTAL_NODE}>
                    <LoadingPage />
                </Portal>
            )}
            {children}
        </LoadingContext.Provider>
    );
}

LoadingContainer.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};

